import mitt from 'mitt';

type Events = Record<string, any>;

const emitter = mitt<Events>();

export function useEventBus() {
  return {
    emit(event: string, payload?: any): void {
      emitter.emit(event, payload);
    },

    /**
     * Returns the unsubscribe function. `off()` needs the exact same handler
     * reference, so an inline arrow passed to `on()` could never be removed and
     * leaked on unmount; the returned disposer removes it reliably.
     */
    on(event: string, handler: (payload?: any) => void): () => void {
      emitter.on(event, handler);
      return () => emitter.off(event, handler);
    },

    off(event: string, handler: (payload?: any) => void): void {
      emitter.off(event, handler);
    }
  };
}

export function fireEvent(event: string, payload?: any): void {
  emitter.emit(event, payload);
}

export { emitter };
